export const gateway = "https://qat-jeminsurance-bms-api.link-nonprod.wawanesalife.com";
export const LoginUrlParameter = "https://qat-brokers.auth.ca-central-1.amazoncognito.com/login?client_id=6l37qgmn3et67vd9lvo7tq4di8&response_type=token&scope=email+openid&redirect_uri=https%3A%2F%2Fqat-jeminsurance-bms.link-nonprod.wawanesalife.com%2Fredirect";
export const assets = "https://qat-assets.link-nonprod.wawanesalife.com/brokers/wawanesalife";
export const HasLinkAdmin = "no";
export const BrokerPoolClientParameter = "6l37qgmn3et67vd9lvo7tq4di8";
export const BrokerPoolDomainParameter = "qat-brokers";
export const BrokerPoolParameter = "ca-central-1_f0PTGfA8O";

export const TopMenuLink1Caption = "Wawanesa Life";
export const TopMenuLink1Url = "https://www.wawanesalife.com";
export const TopMenuLink2Caption = "QuickTerm quoter";
export const TopMenuLink2Url = "https://qat-jeminsurance-shopper.link-nonprod.wawanesalife.com";

//updated on Mon Sep 15 2025 16:13:53 GMT+0000 (Coordinated Universal Time)
